/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { Route, Switch, useParams, useRouteMatch, useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Spin } from "antd";
import AccountBills from "../../components/AccountBills/AccountBills";
import {
  fetchBillStatus,
  fetchBillType,
  fetchServiceStatus,
  fetchPayStatus,
  fetchPaymentSourceTypes,
} from "../../store/slices/rtkDictionaries";
import { fetchBillsByAggId, clearBills } from "../../store/slices/bills";
import AccountBillsDetails from "../../components/AccountBillsDetails/AccountBillsDetails";
import AccountInvoicingTabs from "../../components/AccountInvoicingTabs/AccountInvoicingTabs";
import { fetchGetAgreementsByAccId } from "../../store/slices/agreements";
import { checkIsLoaded, checkNotLoaded } from "../../lib/utils/checkLoadingStatus";
import { fetchProductsByAggId, productsActions } from "../../store/slices/products/products";


const AccountBillsContainer = () => {
  const history = useHistory();
  const { path, url } = useRouteMatch();
  const { accountId } = useParams();
  const { search } = useLocation();
  const serviceIdFromUrl = new URLSearchParams(search).get("serviceId");
  const dispatch = useDispatch();
  const { bills, billsLoading } = useSelector((state) => state.bills);
  const { agreements, agreementsLoading } = useSelector((state) => state.agreements);
  const {
    billStatus,
    billType,
    billStatusLoading,
    billTypeLoading,
    serviceStatusLoading,
    payStatusLoading,
    paymentSourceTypesLoading,
  } = useSelector((state) => state.rtkDictionaries);
  const [billsFilterValues, setBillsFilterValues] = useState({
    isServicesIncludePastDates: false,
    activeBillStatusIds: [1, 2, 7],
    activePayStatusIds: [],
    activeIds: [],
  });
  const [billsPageNumber, setBillsPageNumber] = useState(1);

  useEffect(() => {
    if (!checkIsLoaded(payStatusLoading)) dispatch(fetchPayStatus());
    if (!checkIsLoaded(billStatusLoading)) dispatch(fetchBillStatus());
    if (!checkIsLoaded(billTypeLoading)) dispatch(fetchBillType());
    if (!checkIsLoaded(serviceStatusLoading)) dispatch(fetchServiceStatus());
    if (!checkIsLoaded(paymentSourceTypesLoading)) dispatch(fetchPaymentSourceTypes());
  }, []);

  // Загрузка договоров
  useEffect(() => {
    const isAnotherAccount =
      agreements.length > 0 && Number(agreements[0].accountId) !== Number(accountId);
    if (isAnotherAccount || checkNotLoaded(agreementsLoading)) {
      dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
    }
  }, [agreements]);

  // Загрузка продуктов
  // Убрали при переходе на поддержку пакетов (требовалась иерархия)
  // useEffect(() => {
  //   if (checkIsLoaded(agreementsLoading)) {
  //     const agreementsIds = agreements.map((item) => item.id);
  //     dispatch(
  //       fetchServiceByAggId({
  //         agreementsIds,
  //         futureDates: !billsFilterValues.isServicesIncludePastDates,
  //         includePastDates: billsFilterValues.isServicesIncludePastDates,
  //       })
  //     );
  //   }
  // }, [billsFilterValues.isServicesIncludePastDates, agreementsLoading]);

  // Загрузка иерархии продуктов
  useEffect(() => {
    if (checkIsLoaded(agreementsLoading) && agreements.length !== 0) {
      const agreementsIds = agreements.map((item) => item.id);

      dispatch(fetchProductsByAggId({
        agreementsIds,
        futureDates: !billsFilterValues.isServicesIncludePastDates,
        includePastDates: billsFilterValues.isServicesIncludePastDates,
        // true так как иначе не приходят данные в serviceProfile.paymentTypeId
        extendedInfo: true,
      }));
    }
  }, [billsFilterValues.isServicesIncludePastDates, agreementsLoading]);

  // Загрузка счетов
  useEffect(() => {
    if (checkIsLoaded(agreementsLoading)) {
      const agreementsIds = agreements.map((item) => item.id);
      dispatch(fetchBillsByAggId({ aggId: agreementsIds }));
    }
  }, [agreementsLoading]);

  // Очистка счетов и продуктов по выходу
  useEffect(
    () => () => {
      dispatch(productsActions.cleanProductList());
      dispatch(clearBills());
    },
    []
  );

  const handleSetBillsFilterValues = (prop) => {
    setBillsFilterValues((prev) => ({ ...prev, ...prop }));
    // Удаление из адреса поисковых параметров (serviceId) полученныхbпри переходе из продуктов по ссылке "Счета по продукту"
    if (serviceIdFromUrl) {
      const [propName] = Object.keys(prop);
      if (propName === "selectedServiceId") {
        history.push(url);
      }
    }
  };

  const toggleServicesIncludePastDates = (e) => {
    const { checked } = e.target;
    handleSetBillsFilterValues({ isServicesIncludePastDates: checked });
  };

  // Установка фильтра по продукту при переходе из продукта по ссылке "Счета по продукту"
  useEffect(() => {
    if (serviceIdFromUrl) {
      setBillsFilterValues((prev) => ({ ...prev, selectedServiceId: Number(serviceIdFromUrl) }));
    }
  }, [serviceIdFromUrl]);

  const refetchBills = () => {
    if (agreements.length !== 0) {
      const aggSet = new Set();
      agreements.map((item) => {
        aggSet.add(item.id);
      });
      dispatch(fetchBillsByAggId({ aggId: [...aggSet] }));
    }
  };

  const renderAccountBills = () => (
    <Spin
      spinning={
        !checkIsLoaded(billStatusLoading) ||
        !checkIsLoaded(billTypeLoading) ||
        !checkIsLoaded(serviceStatusLoading) ||
        !checkIsLoaded(payStatusLoading)
      }
    >
      <Switch>
        <Route path={`${path}/newInvoicing`}>
          <AccountInvoicingTabs
            toggleServicesIncludePastDates={toggleServicesIncludePastDates}
            isServicesIncludePastDates={billsFilterValues.isServicesIncludePastDates}
          />
        </Route>
        <Route path={`${path}/details/:billId`}>
          <AccountBillsDetails />
        </Route>
        <AccountBills
          billStatus={billStatus}
          billType={billType}
          bills={bills}
          billsLoading={billsLoading}
          refetchBills={refetchBills}
          billsFilterValues={billsFilterValues}
          handleSetBillsFilterValues={handleSetBillsFilterValues}
          billsPageNumber={billsPageNumber}
          setBillsPageNumber={setBillsPageNumber}
        />
      </Switch>
    </Spin>
  );

  return renderAccountBills();
};

export default AccountBillsContainer;
